import React, { Component } from 'react';

// components
import Modal from '../../../../components/Modal';
import LocationMap from './LocationMap';

// css
import './styles.css';

class LocationModal extends Component {
  render() {
    const { address, location, onDismiss } = this.props;

    return (
      <Modal title="Local de Entrega" size="small" onBackdropClick={onDismiss}>
        <LocationMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div className="LocationModal__loading-el" />}
          containerElement={<div className="LocationModal__container-el" />}
          mapElement={<div className="LocationModal__map-el" />}
          location={location}
        />

        <span className="LocationModal__address">{address}</span>
      </Modal>
    );
  }
}

LocationModal.propTypes = {};
LocationModal.defaultProps = {};

export default LocationModal;
